import employeeCategoryDetails from './employeeCategoryDetails';
import shares from './shares';
import enrollmentCard from './enrollmentCard';

const ltiPlansWidget = {
  LTI_PLAN_CARD_TITLE: 'Your Long Term Incentives',
  LTI_PLAN_CARD_SUB_TITLE: 'Current shareholdings and future vesting in one place',
  LTI_SUMMARY_TOTAL: 'TOTAL VESTING',
  LTI_PLAN_NAME: 'Plan Name',
  LTI_PLAN_TOTAL: 'TOTAL',
  LTI_PLAN_TOTAL_BY_YEAR: 'Total by Year',
  LTI_PLAN_DESCRIPTION: 'Long Term Incentives description',
  LTI_PLAN_DIALOG_START_DATE_LABEL: 'Start date',
  LTI_PLAN_DIALOG_DESCRIPTION_LABEL: 'Description',
  LTI_FUTURE_VESTING_TITLE: 'My Long Term Incentives',
  LTI_FUTURE_VESTING_LABEL: '(Vesting Values By Year)',
  LTI_FUTURE_VESTING_SUB_TITLE: 'Indicative values for awards vesting over the next 6 years to %YEAR%',
  LTI_YEARLY_PLAN_TITLE: 'Yearly Distribution',
  LTI_PLAN_CARDS_LABEL: 'Funding Distribution across %COUNT% plans',
};

export default {
  PAGE_TITLE: 'Welcome',
  DASHBOARD_DESCRIPTION: `Welcome to your total reward statement*.<br>Within your statement you can see the full breakdown of all the different categories of reward elements that you receive.<br>You can drill down and see detailed information about these reward components and provide anonymous feedback.<br>
   We hope you will find this information useful in understanding the true value of your total reward package.
  `,
  ES_HOME: 'Home',
  ES_OVERALL: 'Overall',
  PROFILE_CARD_TITLE: 'Personal Details',
  PROFILE_CARD_COUNTRY_LABEL: 'Country',
  PROFILE_CARD_EMPLOYEE_ID_LABEL: 'Employee ID',
  PROFILE_CARD_EMPLOYEE_NAME: 'Employee Name',
  PROFILE_CARD_GRADE_LABEL: 'Grade',
  MIMIC_EMPLOYEE_BANNER:
    'You are currently viewing Employee Statement as %EMPLOYEE_NAME% %EMPLOYEE_ID%',
  MIMIC_EMPLOYEE_EXIT_LABEL: 'Exit mimic mode',
  NO_REWARDS_FOUND_TITLE: 'My rewards',
  NO_REWARDS_FOUND:
    'There aren’t any rewards assigned to you. Please contact the HR team so you can get access to your rewards.',
  EXTRA_PANEL_DESC: 'The rewards shown in this category are not included in your overall benefit.',
  STATEMENT_DOWNLOAD_DATE: 'Statement Download Date: %DATE%',
  DOWNLOAD_PDF_STATEMENT: 'Download Statement',
  PDF_PREVIEW_TITLE: 'PDF preview - %VIEW%',
  PDF_PREVIEW_SUBTITLE: 'Page 1: Overall view - then a line-by-line page per category. Final page:  Long Term Incentives & Shares',
  PDF_SAVE_AS_PDF: 'Save as PDF',
  PDF_STATEMENT_KICKER: 'Total Reward Statement',
  PDF_REWARD_SNAPSHOT_TITLE: 'Your Reward Snapshot',
  PDF_LOCATION_CURRENCY_LABEL: 'Location / Currency',
  PDF_REPORTED_IN_LABEL: 'Reported in %CURRENCY%',
  PDF_TOTAL_COMPENSATION_LABEL: 'Your Total Compensation Value',
  PDF_CATEGORY_COLUMN: 'Category',
  PDF_VALUE_COLUMN: 'Value',
  PDF_PERCENT_COLUMN: '% of total',
  PDF_DETAIL_COLUMN: 'Detail on page',
  PDF_TOTAL_LABEL: 'Total',
  PDF_FOOTER_PERIOD: 'Next 12 Months',
  PDF_PAGE_LABEL: 'Page %PAGE% of %TOTAL%',
  PDF_FOOTER_DISCLAIMER: 'This statement is illustrative and does not form part of your contract of employment.',
  PDF_CATEGORY_SUBTITLE: 'Next 12 Months - Line-by-line detail',
  PDF_CATEGORY_CONTINUED_SUBTITLE: 'Next 12 Months - continued',
  PDF_CATEGORY_TOTAL_LABEL: '%CATEGORY% total',
  PDF_TOTAL_COMPENSATION_SUFFIX: 'of your total compensation value',
  PDF_LINE_BY_LINE_BREAKDOWN: 'Line-by-line breakdown',
  PDF_REWARD_LINE_COLUMN: 'Reward line',
  PDF_PERCENT_OF_CATEGORY_COLUMN: '% of %CATEGORY%',
  PDF_TOTAL_CATEGORY_LABEL: 'Total %CATEGORY%',
  PDF_WHAT_THIS_INCLUDES: 'What this includes',
  PDF_LTI_VESTING_BY_YEAR: 'Expected LTI Vesting By Year',
  PDF_SHARE_PLAN_COLUMN: 'Share plan',
  PDF_SHARE_VESTED_COLUMN: 'Vested',
  PDF_SHARE_UNVESTED_COLUMN: 'Unvested',
  PDF_SHARE_PRICE_COLUMN: 'Price per share',
  PDF_SHARE_TOTAL_VALUE_COLUMN: 'Total value',
  NAV_ASSISTANT_LABEL: 'Ask Reward Assistant',
  NAV_STATEMENT_LABEL: 'My Statement',
  NAV_MANAGER_LABEL: 'Manager View',
  BANNER_HEADER_DESC1: "Everything you've earned. \nEverything available. \nAll in one place.",
  BANNER_SUB_HEADER_DESC1: "Your total reward \u2013 look back on what you've earned and discover what is available.",
  BANNER_HEADER_DESC2: 'Welcome back,',
  BANNER_SUB_HEADER_DESC2: 'Your personalised rewards overview is ready to explore.',
  STMT_VIEW_SELECTOR_REWARD_SNAPSHOT_TITLE: 'Your Reward Snapshot',
  STMT_VIEW_SELECTOR_THIS_YEAR_LABEL: 'Next 12 Months',
  STMT_VIEW_SELECTOR_ANNUAL_STATEMENT_LABEL: '%YEAR% Annual Pay Review',
  STMT_VIEW_SELECTOR_LAST_YEAR_LABEL: 'Last 12 Months',
  STMT_VIEW_SELECTOR_LAST_VS_THIS_YEAR_LABEL: 'Last 12 vs Next 12 Months',
  ENROLLMENT_WIDGET_SUB_TITLE: 'Tap to shape your package',
  CURRENT_REWARD_SNAPSHOT_LABEL: "What's ahead for you",
  CURRENT_REWARD_SNAPSHOT_DESC: 'Your potential in the next 12 months',
  REWARD_SNAPSHOT_CATEGORY_LABEL: 'Categories',
  REWARD_SNAPSHOT_EXTRA_CATEGORY_LABEL: 'Extra Categories',
  YOUR_TOTAL_REWARD_TITLE: 'Your Total Reward',
  TOTAL_REWARD_SUB_TITLE: 'By Category',
  TOTAL_REWARD_HINT: 'Tap to explore your rewards',
  TOTAL_REWARD_PERCENT: '% of total reward',
  INTERACTIVE_MODELLERS_TITLE: 'Model Your Bonus',
  INTERACTIVE_MODELLERS_SUB_TITLE: 'Explore how your reward could change with different assumptions',
  INTERACTIVE_MODELLERS_HINT: 'Tap to explore scenarios',
  INTERACTIVE_MODELLERS_BONUS: 'Bonus',
  INTERACTIVE_MODELLERS_LTI_SHARES: 'LTI / Shares - soon',
  INTERACTIVE_MODELLERS_BONUS_COMP: 'Bonus Compensation',
  INTERACTIVE_MODELLERS_BONUS_MIDPOINT_PERC: 'Bonus Midpoint %',
  INTERACTIVE_MODELLERS_BONUS_MIDPOINT_VALUE: 'Bonus Midpoint Value',
  INTERACTIVE_MODELLERS_BONUS_MIDPOINT_HINT_TXT: 'Compensation × Midpoint %',
  IM_IPM: 'Individual Performance Multiplier',
  IM_BPM: 'Business Performance Multiplier',
  IM_BPM_HINT_TEXT: 'Changeable Scale (0% – 200%)',
  IM_SUMMARY_BMV: 'Bonus Midpoint Value',
  IM_SUMMARY_PBP: 'Projected Bonus Payout',
  IM_SUMMARY_VS: 'vs Midpoint',
  IM_PSP_ANNUAL_SAL: 'Annual Salary',
  IM_PSP_ANNUAL_SAL_HINT_TXT: 'Pay › Compensation › Annual Salary',
  IM_PSP_TARGET_BONUS_PERC: 'Target Bonus %',
  IM_PSP_HINT_TXT: 'Logic based on Country and Grade',
  IM_PSP_BPM: 'Business Performance Multiplier',
  IM_PSP_BPM_HINT_TXT: 'Changeable Scale (0% – 200%)',
  IM_PSP_SUMMARY_ASP: 'Target ASP Value',
  IM_PSP_SUMMARY_EXPECTED_GRANT: 'Expected ASP / PSP Grant',
  IM_PSP_SUMMARY_VS: 'vs Target',
  PERFORMANCE_BANDS_UNDER: 'Underperforming',
  PERFORMANCE_BANDS_NEEDS_IMP: 'Needs Improvement',
  PERFORMANCE_BANDS_STRONG: 'Strong',
  PERFORMANCE_BANDS_HIGH: 'High Performing',
  PERFORMANCE_BANDS_EXCEED: 'Exceeding',
  SHARE_YOUR_FEEDBACK_TITLE: 'Share your feedback',
  FEEDBACK_SUB_TITLE: 'Rate each reward and help shape what comes next',
  LEGAL_DISCLAIMER_LABEL: 'Legal Disclaimer',
  QUICK_LINKS: 'QUICK LINKS',
  QUICK_LINK_VIEW_PAYSLIPS: 'View Payslips (Workday)',
  QUICK_LINK_EQUATE_PLUS: 'Equate Plus (Computershare)',
  QUICK_LINK_FIDELITY: 'NetBenefits (Fidelity)',
  QUICK_LINK_GOALS: 'Goals (Workday)',
  QUICK_LINK_REWARD_HUB: 'Unilever Reward Hub',
  QUICK_LINK_FIDELITY_URL: 'https://launcher.myapps.microsoft.com/api/signin/ef636131-5c60-45d4-acb1-de5e5cea75a3?tenantId=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  QUICK_LINK_PAYSLIP_URL: 'https://wd3.myworkday.com/unilever/d/task/2997$1475.htmld',
  QUICK_LINK_EQUATE_PLUS_URL: 'https://myapps.microsoft.com/signin/ComputerShare/687b35a9-4aca-4992-8bed-ce2e093ae9df',
  QUICK_LINK_GOALS_URL: 'https://wd3.myworkday.com/unilever/d/task/23748$34.htmld#TABINDEX=0',
  QUICK_LINK_REWARD_HUB_URL: 'https://unilever.sharepoint.com/sites/UnileverRewardHub',
  TOTAL_REWARD_BREAKDOWN: 'TOTAL REWARD BREAKDOWN',
  BAR_TOGGLE_LABEL: 'Bar',
  PIE_TOGGLE_LABEL: 'Pie',
  ...employeeCategoryDetails,
  ...shares,
  ...enrollmentCard,
  ...ltiPlansWidget,
};
